module.exports = __webpack_public_path__ + "img/Legendaarinen-Nalle.07d858fb.png";